export const colors = {
    ffGreen: '#01916d',
};
